import axios from "axios";
import { useState } from "react";
import AsyncSelect from "react-select/async";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

const SelectCustomerReport = ({ aamarId, onCustomerSelect }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const fetchCustomers = async (inputValue, callback) => {
    try {
      const result = await axios.get(
        `${BASE_URL}customer/search/${aamarId}/${inputValue}`
      );

      let options = result.data.map((customer) => ({
        label: `${customer.name} - [ ${customer.phone} ]`,
        value: customer._id,
      }));

      callback(options);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  const handleChange = (selected) => {
    setSelectedOption(selected);
    onCustomerSelect(selected ? selected.value : null); // Selected ID pass to parent
  };

  return (
    <AsyncSelect
      value={selectedOption}
      loadOptions={fetchCustomers}
      placeholder="Select a Customer"
      onChange={handleChange}
      defaultOptions
      className="basic-single"
      classNamePrefix="select"
      isClearable
    />
  );
};

export default SelectCustomerReport;
